import { loadNotes, saveNotes, clearNotes } from '../services/notesService';

let saveTimeout = null;
let isInitialized = false;

/**
 * Initialise le modal des notes
 */
export function initNotesModal() {
  // Éviter les initialisations multiples
  if (isInitialized) {
    console.log('🔒 NotesModal déjà initialisé');
    return;
  }

  const notesBtn = document.getElementById('notes-btn');
  const modal = document.getElementById('notes-modal');
  const closeBtn = document.getElementById('close-notes-modal');
  const closeNotesBtn = document.getElementById('close-notes');
  const clearNotesBtn = document.getElementById('clear-notes');
  const textarea = document.getElementById('notes-textarea');

  if (!notesBtn || !modal || !closeBtn || !textarea) {
    console.error('Éléments du modal des notes non trouvés');
    return;
  }

  // Marquer comme initialisé
  isInitialized = true;
  console.log('✅ Initialisation du modal des notes');

  // Ouvrir le modal
  notesBtn.addEventListener('click', async () => {
    modal.style.display = 'flex';

    // Charger les notes existantes
    try {
      const notes = await loadNotes();
      textarea.value = notes;
    } catch (error) {
      console.error('Erreur lors du chargement des notes:', error);
    }

    // Focus sur le textarea
    setTimeout(() => textarea.focus(), 100);
  });

  // Fermer avec le bouton X - UTILISER LA FONCTION GLOBALE
  closeBtn.addEventListener('click', () => {
    window.closeModal('notes-modal');
  });

  // Fermer avec le bouton Fermer
  if (closeNotesBtn) {
    closeNotesBtn.addEventListener('click', () => {
      window.closeModal('notes-modal');
    });
  }

  // Fermer en cliquant en dehors
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      window.closeModal('notes-modal');
    }
  });

  // Empêcher la fermeture sur le contenu
  const modalContent = modal.querySelector('.modal-content');
  if (modalContent) {
    modalContent.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  }

  // Sauvegarde automatique avec debounce amélioré
  let saveDebounceTimer = null;
  textarea.addEventListener('input', () => {
    // Annuler le timeout précédent
    if (saveDebounceTimer) {
      clearTimeout(saveDebounceTimer);
    }

    // Programmer une sauvegarde après 1 seconde d'inactivité
    saveDebounceTimer = setTimeout(async () => {
      try {
        await saveNotes(textarea.value);
        console.log('💾 Notes sauvegardées automatiquement');
      } catch (error) {
        console.error('Erreur lors de la sauvegarde automatique:', error);
      }
    }, 1000);
  });

  // Effacer les notes avec protection contre les événements multiples
  if (clearNotesBtn) {
    let clearInProgress = false;

    clearNotesBtn.addEventListener('click', async () => {
      if (clearInProgress) return; // Éviter les clics multiples

      if (confirm('Es-tu sûr de vouloir effacer toutes les notes ? Cette action est irréversible.')) {
        clearInProgress = true;
        try {
          await clearNotes();
          textarea.value = '';
          console.log('✅ Notes effacées');
        } catch (error) {
          console.error('Erreur lors de l\'effacement des notes:', error);
          alert('Erreur lors de l\'effacement des notes');
        } finally {
          clearInProgress = false;
        }
      }
    });
  }
}

/**
 * Fonction utilitaire pour ouvrir le modal des notes
 */
export function showNotesModal() {
  const notesBtn = document.getElementById('notes-btn');
  if (notesBtn) {
    notesBtn.click();
  }
}